import React, { ReactElement, useContext } from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar, faBolt, faAward, faMoneyBill } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from '../contexts/AppContext'
import { isUsingField } from '../contexts/app/auth'
import { AppContextState } from '../contexts/AppContext.d'
import { VoiceRecorder } from './VoiceRecord'
import { SimpleWriteProps } from './Write.d'
library.add(faStar, faBolt, faAward, faMoneyBill)

const isUsingRatings = (appState: AppContextState): boolean =>
    isUsingField('rating', appState) || isUsingField('energy', appState) || isUsingField('importance', appState)

const RatingsAndPriceBlock = (props: SimpleWriteProps): ReactElement => {
    const { appState } = useContext(AppContext)
    if (!isUsingRatings(appState) && !isUsingField('price', appState) && !isUsingField('voice', appState)) {
        return <></>
    }
    return <div className="entry-write-metadata">
        { isUsingField('voice', appState) && <VoiceRecorder /> }
        { isUsingRatings(appState) && <RatingsBlock entry={ props.entry } setValue={ props.setValue } /> }
        { isUsingField('price', appState) && <PriceField entry={ props.entry } setValue={ props.setValue } /> }
    </div>
}

const RatingsBlock = (props: SimpleWriteProps): ReactElement => {
    const { appState } = useContext(AppContext)
    return <div className="no-line-wrap">
        { isUsingField('rating', appState) && <RatingField entry={ props.entry } setValue={ props.setValue } />}
        { isUsingField('energy', appState) && <EnergyField entry={ props.entry } setValue={ props.setValue } /> }
        { isUsingField('importance', appState) && <ImportanceField entry={ props.entry } setValue={ props.setValue } />}
    </div>
}

const RatingField = (props: SimpleWriteProps): ReactElement =>
    <div className="no-line-wrap">
        <label htmlFor="rating"><FontAwesomeIcon icon="star" /></label>
        <input
            id="rating"
            value={ props.entry.rating || '' }
            placeholder="e.g. 4"
            type="number"
            step="0.1"
            onChange={ e => props.setValue('rating', Number(e.target.value) || undefined) } />
    </div>

const EnergyField = (props: SimpleWriteProps) =>
    <div className="no-line-wrap">
        <label htmlFor="energy"><FontAwesomeIcon icon="bolt" /></label>
        <input
            id="energy"
            value={ props.entry.energy || '' }
            placeholder="e.g. 3"
            type="number"
            step="0.1"
            onChange={ e => props.setValue('energy', Number(e.target.value) || undefined) } />
    </div>

const ImportanceField = (props: SimpleWriteProps) =>
    <div className="no-line-wrap">
        <label htmlFor="importance"><FontAwesomeIcon icon="award" /></label>
        <input
            id="importance"
            value={ props.entry.importance || '' }
            placeholder="e.g. 5"
            type="number"
            step="0.1"
            onChange={ e => props.setValue('importance', Number(e.target.value) || undefined) } />
    </div>

const PriceField = (props: SimpleWriteProps) =>
    <div className="no-line-wrap">
        <label htmlFor="price"><FontAwesomeIcon icon="money-bill" /></label>
        <input
            id="price"
            value={ props.entry.price || '' }
            placeholder="e.g. €35"
            onChange={ e => props.setValue('price', e.target.value) } />
    </div>

export default RatingsAndPriceBlock
